import { useEffect, useState } from "react";
import TableCustom from "../../../../components/table/tableCustom";
import CustomStatus from "../../../../components/chip/CustomStatus";
import {
  FiberManualRecord,
  FileDownloadOutlined,
  RemoveRedEyeOutlined,
} from "@mui/icons-material";
import { NavigateFunction, useNavigate } from "react-router-dom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { useTranslation } from "react-i18next";
import { StudentApi } from "../../../../api/student/student.api";
import { dateToView } from "../../../../utils/date.utils";
import ModalTermFeesDetail from "./ModalTermFeesDetail";

const TermFeeInfo = ({ student_id }: { student_id: number }) => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();

  const [data, setData] = useState<any>([]);
  const [dataModal, setDataModal] = useState<any>({});

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>();
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");

  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const headCells = [
    {
      id: "#",
      width: 2,
      disablePadding: false,
      align: "center",
      label: "#",
    },
    {
      id: "year",
      width: 35,
      disablePadding: false,
      align: "start",
      label: t("STUDENT_MANAGEMENT.TERM_FEE.TABLE.YEAR_COLUMN"),
    },
    {
      id: "term",
      disablePadding: false,
      width: 50,
      align: "center",
      label: t("STUDENT_MANAGEMENT.TERM_FEE.TABLE.TERM_COLUMN"),
    },
    {
      id: "stp_payment_date",
      disablePadding: false,
      align: "center",
      width: 35,
      label: t("STUDENT_MANAGEMENT.TERM_FEE.TABLE.PAYMENT_DATE_COLUMN"),
    },
    {
      id: "stp_payment_time",
      disablePadding: false,
      align: "center",
      width: 50,
      label: t("STUDENT_MANAGEMENT.TERM_FEE.TABLE.PAYMENT_TIME_COLUMN"),
    },
    {
      id: "stp_payment_currency",
      disablePadding: false,
      align: "center",
      width: 35,
      label: t("STUDENT_MANAGEMENT.TERM_FEE.TABLE.CURRENCY_COLUMN"),
    },
    {
      id: "stp_payment_amount",
      disablePadding: false,
      align: "center",
      width: 35,
      label: t("STUDENT_MANAGEMENT.TERM_FEE.TABLE.BALANCE_AMOUNT_COLUMN"),
    },
    {
      id: "auditor",
      disablePadding: false,
      align: "center",
      width: 75,
      label: t("STUDENT_MANAGEMENT.TERM_FEE.TABLE.AUDITOR_COLUMN"),
    },
    {
      id: "audit_date",
      disablePadding: false,
      align: "center",
      width: 50,
      label: t("STUDENT_MANAGEMENT.TERM_FEE.TABLE.AUDIT_DATE_COLUMN"),
    },
    {
      id: "stp_status",
      disablePadding: false,
      align: "center",
      width: 75,
      label: t("STUDENT_MANAGEMENT.TERM_FEE.TABLE.STATUS_COLUMN"),
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 50,
      label: "action",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id,
      stp_year,
      stp_term,
      stp_payment_date,
      stp_payment_time,
      stp_payment_currency,
      stp_payment_amount,
      auditor,
      audit_date,
      stp_status,
    } = objData;

    const objRenderData = {
      key: id,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: `${no}` || "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: `${stp_year}` || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: stp_term || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: stp_payment_date ? dateToView(stp_payment_date, false) : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: stp_payment_time || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: stp_payment_currency || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: stp_payment_amount || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: auditor || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: audit_date || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <>
              <CustomStatus
                label={
                  stp_status === "active"
                    ? "ชำระค่าเทอมเรียบร้อยแล้ว"
                    : "ยังไม่ชำระค่าเทอมเรียบร้อยแล้ว"
                }
                type="outlined"
                color={stp_status === "active" ? "success" : "error"}
                icon={<FiberManualRecord />}
              />
            </>
          ),
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <>
              <FileDownloadOutlined
                onClick={() => { }}
                style={{
                  cursor: "pointer",
                  marginRight: "25px",
                }}
              />
              <RemoveRedEyeOutlined
                onClick={() => {
                  setDataModal(objData);
                  setIsShowModal(true);
                }}
                style={{
                  cursor: "pointer",
                }}
              />
            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const getTermFee = async (student_id: number) => {
    const res = await StudentApi.fetchGetTermFees(student_id);
    const data = res.data;
    if (data.status < 300) {
      setData(data.data);
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    if (student_id) {
      getTermFee(student_id);
    }
  }, [student_id]);
  return (
    <>
      <ModalTermFeesDetail
        setIsOpenModal={(isOpen: boolean) => setIsShowModal(isOpen)}
        isOpenModal={isShowModal}
        data={dataModal}
      />
      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </>
  );
};

export default TermFeeInfo;
